module.exports = __webpack_public_path__ + "static/media/background.0568d5f1.jpg";